import React, { Component } from 'react';
import './App.css';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import qs from 'qs';
import FormGroup from '@material-ui/core/FormGroup';
import axios from 'axios';
import ModalPopup from './ModalPopup';
import ModalPopupLRG from './ModalPopupLRG';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { urlConfig } from "./config";

const styles = theme => ({
  container: {
    position: 'relative',
  },
});

class LowResGeneration extends Component {
  constructor(props) {
    super(props);

    const parsed = qs.parse(this.props.location.search);
    const cid = parsed['cid'] || '';
    const path = parsed['?path'] || '';

    this.state = {
      cid,
      path,
      isloading: false,
      show: false,
      message: '',
    };
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };


  lowResGeneration = (event) => {
    event.preventDefault();

    this.setState({
      isloading: true,
      show: false,
      message: '',
    });

    const { cid, path } = this.state;
    const cidList = cid.split(',').map(c => c.trim()).filter(Boolean);
    const userEmail = sessionStorage.getItem("userEmail");

    // const baseUrl = "https://pp1.vuclip.com/lowres2";

    cidList.forEach(singleCID => {
      const data = {
        Path: path.charAt(0) === '/' ? path.slice(1) : path,
        Cid: singleCID,
        userEmail: userEmail,
      };

      // axios.post(`${baseUrl}?c=${singleCID}&path=${path}`, data)
      axios.post(`${urlConfig.lowresUrl}?c=${singleCID}&path=${path}`, data)
        .then(() => {
          console.log(`CID ${singleCID} submitted successfully.`);
        })
        .catch(err => {
          console.warn(`CID ${singleCID} failed (but ignoring for UX):`, err);
        });
    });

    // Immediately show success message
    this.setState({
      isloading: false,
      message:
        'Your request has been submitted successfully. Please check after some time.',
      cid: '',
      path: '',
    });
  };

  render() {
    const { classes } = this.props;
    const { path, cid, isloading, show, message } = this.state;

    const onClickPopupClose = () => this.setState({ show: false });
    const onClickPopupOpen = (e) => {
      e.preventDefault();
      this.setState({ show: true });
    };

    return (
      <React.Fragment>
        <Paper>
          <Grid
            container
            spacing={0}
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              <form onSubmit={onClickPopupOpen}>
                <FormGroup row>
                  <Grid
                    container
                    spacing={2}
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                  >
                    <Grid item xs={8}>
                      <TextField
                        label="Path"
                        name="path"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        required
                        margin="normal"
                        value={path}
                        onChange={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        label="CID(s) (comma-separated)"
                        name="cid"
                        variant="outlined"
                        fullWidth
                        required
                        margin="normal"
                        value={cid}
                        onChange={this.handleChange}
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <Button
                        disabled={isloading}
                        variant="contained"
                        color="primary"
                        type="submit"
                        size="large"
                        className={classes.button}
                      >
                        {isloading ? 'Submitting...' : 'Submit'}
                      </Button>
                    </Grid>

                    {show && (
                      <ModalPopupLRG
                        show={show}
                        close={onClickPopupClose}
                        submit={this.lowResGeneration}
                      />
                    )}
                  </Grid>
                </FormGroup>
              </form>

              <ModalPopup />

              <style jsx>
                {`
                  .message {
                    margin-top: 20px;
                    font-size: 1rem;
                    font-weight: 500;
                    text-align: center;
                  }
                `}
              </style>

              
              {message && (
                <p className="message" style={{ color: '#006400' }}>
                  {message}
                </p>
              )}
              <br />
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

LowResGeneration.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles, { withTheme: true })(LowResGeneration));

